// extracted by mini-css-extract-plugin
export var icon = "_6d-1";
export var subtext = "_6d-0";